'use client';

import { Box, Typography } from '@mui/material';
import {
  animatedPriceContainerStyles,
  currencySymbolStyles,
  priceSlotContainerStyles,
} from './AnimatedPrice.styled';

import SlotCounter from 'react-slot-counter';

interface AnimatedPriceProps {
  price: string | number | undefined;
  currency?: string;
  variant?: 'h10';
  fontWeight?: number;
}

export default function AnimatedPrice({
  price,
  currency,
  variant = 'h10',
  fontWeight = 400,
}: AnimatedPriceProps) {
  if (price === undefined) return null;

  const priceValue =
    typeof price === 'string' ? price : (price?.toString() ?? '0');

  return (
    <Typography
      variant={variant}
      sx={animatedPriceContainerStyles}
      fontWeight={fontWeight}
    >
      {currency && (
        <Box component="span" sx={currencySymbolStyles}>
          {currency}
        </Box>
      )}
      <Box component="span" sx={priceSlotContainerStyles}>
        <SlotCounter
          value={priceValue}
          duration={0.6}
          direction="bottom-up"
          animateUnchanged={false}
          numberSlotClassName="price-slot-number"
          separatorClassName="price-slot-separator"
        />
      </Box>
    </Typography>
  );
}
